//域名
const domain = window.location.host + "/api";

//端口
const port = null;

//路径
const root = window.location.protocol + "//" + domain + (port ? (":" + port) : "");
// const root = "http://127.0.0.1:9100/";

//接口
const api = {};

export default Object.assign(
    {
        $base: {
            domain: domain,
            port: port,
            root: root,
        },
        spDevice:{
            add:`${root}/spDevice/add`,
            update:`${root}/spDevice/update`,
            delete:`${root}/spDevice/delete`,
            list:`${root}/spDevice/list`,
            detail:`${root}/spDevice/detail`,
            batchDelete:`${root}/spDevice/batchDelete`
        },
        spDevLog:{
            delete:`${root}/spDevLog/delete`,
            list:`${root}/spDevLog/list`,
            detail:`${root}/spDevLog/detail`,
            clearLog:`${root}/spDevLog/clearLog`,
            batchDelete:`${root}/spDevLog/batchDelete`
        },
        spDevServer:{
            add:`${root}/spDevServer/add`,
            update:`${root}/spDevServer/update`,
            delete:`${root}/spDevServer/delete`,
            list:`${root}/spDevServer/list`,
            detail:`${root}/spDevServer/detail`,
            batchDelete:`${root}/spDevServer/batchDelete`
        },
        spDevAdminCommon:{
            qrCode:`${root}/spDevAdminCommon/qrCode`
        }
    },
    api
)
